(() => {
  if (window.__ghQuickViewLoaded) return;
  window.__ghQuickViewLoaded = true;

  const COLOR_HEX = {
    black: '#111111',
    'dark black': '#1a1a1a',
    white: '#f3f3f3',
    grey: '#8d8d8d',
    gray: '#8d8d8d',
    navy: '#1f2a44',
    blue: '#2c5aa0',
    green: '#3f5d3a',
    olive: '#556b2f',
    'olive green': '#556b2f',
    orange: '#f58220',
    red: '#b42318',
    brown: '#6b4a2b',
    beige: '#d6c4a8',
    cream: '#efe6d2',
    pink: '#e8a0b0',
    yellow: '#e4c44a',
    purple: '#5b3d7a',
    gold: '#c6a15b',
    silver: '#c0c0c0',
    tan: '#c4a574',
    khaki: '#9a8f5a',
    maroon: '#6e1f2c'
  };

  const cache = {};
  const state = {
    product: null,
    selected: {},
    image: '',
    quantity: 1
  };

  const absUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    return url;
  };

  const formatMoney = (cents) => {
    const value = Math.round(Number(cents || 0) / 100);
    return `₹${value.toLocaleString('en-IN')}`;
  };

  const optionKey = (name = '') => String(name).trim().toLowerCase();
  const isColorOption = (name) => /colou?r/i.test(name);
  const isSizeOption = (name) => /size/i.test(name);
  const isGenderOption = (name) => /looking|gender/i.test(name);

  const optionLabel = (name) => {
    if (isSizeOption(name)) return 'Select Size (UK)';
    if (isColorOption(name)) return 'Select Color';
    if (isGenderOption(name)) return 'Select Gender';
    return `Select ${name}`;
  };

  const uniqueImages = (product) => {
    const images = [];
    const push = (url) => {
      const src = absUrl(url);
      if (src && !images.includes(src)) images.push(src);
    };
    push(product.featured_image);
    (product.images || []).forEach(push);
    (product.variants || []).forEach((variant) => push(variant.featured_image?.src));
    return images;
  };

  const findVariant = (product, selected) => {
    return (product.variants || []).find((variant) =>
      (product.options || []).every((option, index) => {
        const chosen = selected[option.name];
        if (!chosen) return true;
        return String(variant[`option${index + 1}`]) === String(chosen);
      })
    );
  };

  const valueAvailable = (product, selected, optionName, value) => {
    const next = { ...selected, [optionName]: value };
    return (product.variants || []).some((variant) => {
      const matches = (product.options || []).every((option, index) => {
        const chosen = next[option.name];
        if (!chosen) return true;
        return String(variant[`option${index + 1}`]) === String(chosen);
      });
      return matches && variant.available;
    });
  };

  const colorHex = (value, product) => {
    const key = optionKey(value);
    if (COLOR_HEX[key]) return COLOR_HEX[key];
    const variant = (product.variants || []).find((item) => optionKey(item.option1) === key || optionKey(item.option2) === key || optionKey(item.option3) === key);
    if (variant?.featured_image?.src) return `url("${absUrl(variant.featured_image.src)}")`;
    return '#d9d9d9';
  };

  const ensureModal = () => {
    let root = document.querySelector('.gh-qv');
    if (root && !root.querySelector('.gh-qv__close--mobile')) {
      root.remove();
      root = null;
    }
    if (root) return root;

    root = document.createElement('div');
    root.className = 'gh-qv';
    root.hidden = true;
    root.innerHTML = `
      <div class="gh-qv__overlay" data-gh-qv-close></div>
      <button class="gh-qv__close gh-qv__close--mobile" type="button" aria-label="Close" data-gh-qv-close>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <path d="M1.5 1.5l9 9M10.5 1.5l-9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
      <div class="gh-qv__dialog" role="dialog" aria-modal="true" aria-labelledby="gh-qv-title">
        <button class="gh-qv__close gh-qv__close--desktop" type="button" aria-label="Close" data-gh-qv-close>&times;</button>
        <div class="gh-qv__gallery">
          <div class="gh-qv__thumbs"></div>
          <div class="gh-qv__stage"><img alt=""></div>
          <div class="gh-qv__carousel"></div>
        </div>
        <div class="gh-qv__panel">
          <div class="gh-qv__info">
            <div class="gh-qv__vendor"></div>
            <h2 class="gh-qv__title" id="gh-qv-title"></h2>
            <div class="gh-qv__price">
              <span class="gh-qv__price-current"></span>
              <span class="gh-qv__price-compare"></span>
              <span class="gh-qv__off" hidden></span>
            </div>
            <div class="gh-qv__options"></div>
          </div>
          <div class="gh-qv__actions">
            <div class="gh-qv__qty">
              <button class="gh-qv__qty-btn" type="button" data-gh-qv-qty="-1" aria-label="Decrease quantity">−</button>
              <span class="gh-qv__qty-value">1</span>
              <button class="gh-qv__qty-btn" type="button" data-gh-qv-qty="1" aria-label="Increase quantity">+</button>
            </div>
            <button class="gh-qv__add" type="button">Add to Bag</button>
          </div>
          <div class="gh-qv__usps">
            <div class="gh-qv__usp">
             <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.9163 14.8776V7.58539C22.9163 7.40327 22.8208 7.23449 22.6646 7.14079C22.4992 7.04153 22.2923 7.04232 22.1277 7.14285L15.1051 11.4303C14.1587 12.0081 13.6855 12.297 13.1794 12.4099C12.7318 12.5095 12.2676 12.5095 11.82 12.4099C11.3138 12.297 10.8406 12.0081 9.89424 11.4303L2.8717 7.14285C2.70703 7.04232 2.50017 7.04153 2.33474 7.14079C2.17857 7.23449 2.08301 7.40327 2.08301 7.58539V14.8776C2.08301 15.9099 2.08301 16.426 2.23112 16.8899C2.3622 17.3003 2.57672 17.6791 2.86122 18.0027C3.18272 18.3683 3.62532 18.6339 4.51053 19.165L9.9272 22.415C10.8625 22.9762 11.3302 23.2568 11.8294 23.3664C12.271 23.4634 12.7283 23.4634 13.17 23.3664C13.6692 23.2568 14.1369 22.9762 15.0722 22.415L20.4888 19.165C21.3741 18.6339 21.8167 18.3683 22.1381 18.0027C22.4226 17.6791 22.6372 17.3003 22.7682 16.8899C22.9163 16.426 22.9163 15.9099 22.9163 14.8776Z" fill="black" fill-opacity="0.1" stroke="black" stroke-width="0.833333"/>
<path d="M7.81205 9.89585L17.1872 4.16669M12.4997 13.0209L21.8747 7.29169M12.4997 13.0209L3.12467 7.29169M12.4997 13.0209V23.4375M2.08301 10.1226V14.8774C2.08301 15.9097 2.08301 16.4259 2.23112 16.8897C2.3622 17.3001 2.57672 17.679 2.86122 18.0025C3.18272 18.3681 3.62532 18.6338 4.51053 19.1649L9.9272 22.4149C10.8625 22.9761 11.3302 23.2567 11.8294 23.3663C12.271 23.4632 12.7283 23.4632 13.17 23.3663C13.6692 23.2567 14.1369 22.9761 15.0722 22.4149L20.4888 19.1649C21.3741 18.6338 21.8167 18.3681 22.1381 18.0025C22.4226 17.679 22.6372 17.3001 22.7682 16.8897C22.9163 16.4259 22.9163 15.9097 22.9163 14.8774V10.1226C22.9163 9.09032 22.9163 8.57416 22.7682 8.11037C22.6372 7.69994 22.4226 7.32104 22.1381 6.99749C21.8167 6.63187 21.3741 6.3663 20.4888 5.83518L15.0722 2.58518C14.1369 2.02399 13.6692 1.7434 13.17 1.63376C12.7283 1.53679 12.271 1.53679 11.8294 1.63376C11.3302 1.7434 10.8625 2.02399 9.9272 2.58518L4.51053 5.83518C3.62532 6.3663 3.18272 6.63187 2.86122 6.99749C2.57672 7.32104 2.3622 7.69994 2.23112 8.11037C2.08301 8.57416 2.08301 9.09032 2.08301 10.1226Z" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

              <span>Free delivery<br>within 4-5 days</span>
            </div>
            <div class="gh-qv__usp">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.6663 2.08337H8.33301C4.88123 2.08337 2.08301 4.88159 2.08301 8.33337V16.6667C2.08301 20.1185 4.88123 22.9167 8.33301 22.9167H16.6663C20.1181 22.9167 22.9163 20.1185 22.9163 16.6667V8.33337C22.9163 4.88159 20.1181 2.08337 16.6663 2.08337Z" fill="black" fill-opacity="0.1" stroke="black" stroke-width="0.833333"/>
<path d="M12.0879 7.72388C13.3748 7.57906 14.6318 8.03758 15.6279 9.01978L15.6396 8.75903C15.6519 8.45829 15.826 8.21991 16.0928 8.21802C16.342 8.21712 16.5428 8.45611 16.543 8.75708L16.5439 10.3147C16.5439 10.4545 16.5022 10.5907 16.4268 10.6936C16.3507 10.7972 16.2386 10.8689 16.1016 10.8694L14.7871 10.8723C14.5135 10.8723 14.3257 10.6257 14.3174 10.3567C14.3092 10.0909 14.4696 9.83095 14.7275 9.8147L14.9971 9.79614C13.7551 8.5854 11.9666 8.42792 10.5908 9.38794C9.36147 10.2463 8.5977 11.8064 8.59766 13.5178C8.59766 13.8203 8.38527 14.0435 8.15137 14.0471C7.88011 14.0506 7.69436 13.8016 7.69434 13.5002C7.69693 10.5262 9.5984 8.00436 12.0879 7.72388Z" fill="black" stroke="black" stroke-width="0.1"/>
<path d="M17.4307 12.7053C17.6444 12.743 17.7949 12.9174 17.7949 13.1438C17.7916 15.5361 15.8735 17.55 13.3789 17.7766C12.1056 17.8924 10.8524 17.5291 9.85449 16.7561L9.83984 17.0491C9.83324 17.1705 9.76165 17.2626 9.66992 17.3206C9.57885 17.378 9.46398 17.4048 9.3584 17.3977C9.25829 17.3906 9.15648 17.3436 9.08008 17.2717C9.00345 17.1995 8.94862 17.0989 8.94824 16.9836L8.94531 15.7122V15.6995L8.94727 15.6965C8.95463 15.4711 9.13723 15.2633 9.375 15.262L10.6807 15.2571C10.8145 15.2564 10.9372 15.2943 11.0283 15.3674C11.1202 15.4412 11.1779 15.5488 11.1826 15.6799C11.1914 15.9304 10.985 16.1205 10.7139 16.1301L10.5088 16.137C11.7618 17.065 13.4821 17.1811 14.8516 16.4417C16.1103 15.7616 16.8864 14.5022 16.8877 13.1292C16.8879 12.8691 17.1107 12.7003 17.3359 12.6975L17.4307 12.7053Z" fill="black" stroke="black" stroke-width="0.1"/>
</svg>

              <span>7 Days free<br>exchange policy</span>
            </div>
          </div>
          <div class="gh-qv__status" aria-live="polite"></div>
        </div>
      </div>
    `;
    document.body.appendChild(root);

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-gh-qv-close]')) closeModal();
      const qty = event.target.closest('[data-gh-qv-qty]');
      if (qty) {
        state.quantity = Math.max(1, state.quantity + Number(qty.dataset.ghQvQty));
        root.querySelector('.gh-qv__qty-value').textContent = String(state.quantity);
      }
      if (event.target.closest('.gh-qv__add')) addToBag();
      const thumb = event.target.closest('.gh-qv__thumb, .gh-qv__slide');
      if (thumb) {
        state.image = thumb.dataset.src;
        renderImage(root);
      }
      const choice = event.target.closest('[data-gh-qv-option]');
      if (choice && !choice.classList.contains('is-unavailable')) {
        state.selected[choice.dataset.ghQvOption] = choice.dataset.ghQvValue;
        const product = state.product;
        const variant = findVariant(product, state.selected);
        if (variant?.featured_image?.src) state.image = absUrl(variant.featured_image.src);
        renderOptions(root);
        renderPrice(root);
        renderImage(root);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) closeModal();
    });

    return root;
  };

  const renderImage = (root, instant) => {
    const img = root.querySelector('.gh-qv__stage img');
    img.src = state.image;
    img.alt = state.product?.title || '';
    root.querySelectorAll('.gh-qv__thumb').forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.src === state.image);
    });
    const carousel = root.querySelector('.gh-qv__carousel');
    if (!carousel) return;
    [...carousel.children].forEach((slide) => {
      const active = slide.dataset.src === state.image;
      slide.classList.toggle('is-active', active);
      if (active) {
        carousel.scrollTo({
          left: slide.offsetLeft,
          behavior: instant ? 'auto' : 'smooth'
        });
      }
    });
  };

  const renderPrice = (root) => {
    const variant = findVariant(state.product, state.selected) || state.product.variants?.[0];
    const price = variant?.price ?? state.product.price;
    const compare = variant?.compare_at_price ?? state.product.compare_at_price;
    root.querySelector('.gh-qv__price-current').textContent = formatMoney(price);
    const compareEl = root.querySelector('.gh-qv__price-compare');
    const offEl = root.querySelector('.gh-qv__off');
    if (compare && compare > price) {
      compareEl.textContent = formatMoney(compare);
      compareEl.hidden = false;
      const percent = Math.round(((compare - price) / compare) * 100);
      offEl.textContent = `${percent}%off`;
      offEl.hidden = percent <= 0;
    } else {
      compareEl.textContent = '';
      compareEl.hidden = true;
      offEl.hidden = true;
    }
    const add = root.querySelector('.gh-qv__add');
    add.disabled = !variant || !variant.available;
    add.textContent = variant?.available ? 'Add to Bag' : 'Sold Out';
  };

  const renderOptions = (root) => {
    const wrap = root.querySelector('.gh-qv__options');
    wrap.innerHTML = '';
    const orderedOptions = [...(state.product.options || [])].sort((a, b) => {
      const rank = (name) => isColorOption(name) ? 0 : isSizeOption(name) ? 1 : 2;
      return rank(a.name) - rank(b.name);
    });
    orderedOptions.forEach((option) => {
      if ((option.values || []).filter((value) => value && value !== 'Default Title').length === 0) return;
      const block = document.createElement('div');
      block.className = 'gh-qv__option';
      const head = document.createElement('div');
      head.className = 'gh-qv__option-head';
      const label = document.createElement('div');
      label.className = 'gh-qv__option-label';
      label.textContent = optionLabel(option.name);
      head.appendChild(label);
      if (isSizeOption(option.name)) {
        const guide = document.createElement('a');
        guide.className = 'gh-qv__size-guide';
        guide.href = window.__ghQuickViewSettings?.sizeGuideUrl || '/pages/size-guide';
        guide.textContent = 'Size Guide';
        head.appendChild(guide);
      }
      block.appendChild(head);

      if (isColorOption(option.name)) {
        const list = document.createElement('div');
        list.className = 'gh-qv__swatches';
        option.values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'gh-qv__swatch';
          button.dataset.ghQvOption = option.name;
          button.dataset.ghQvValue = value;
          if (state.selected[option.name] === value) button.classList.add('is-selected');
          const fill = colorHex(value, state.product);
          const dot = document.createElement('span');
          dot.className = 'gh-qv__swatch-dot';
          if (fill.startsWith('url(')) dot.style.backgroundImage = fill;
          else dot.style.backgroundColor = fill;
          const name = document.createElement('span');
          name.className = 'gh-qv__swatch-name';
          name.textContent = value;
          button.append(dot, name);
          list.appendChild(button);
        });
        block.appendChild(list);
      } else {
        const list = document.createElement('div');
        list.className = isSizeOption(option.name) ? 'gh-qv__sizes' : 'gh-qv__pills';
        option.values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = isSizeOption(option.name) ? 'gh-qv__size' : 'gh-qv__pill';
          button.dataset.ghQvOption = option.name;
          button.dataset.ghQvValue = value;
          button.textContent = value;
          if (state.selected[option.name] === value) button.classList.add('is-selected');
          if (!valueAvailable(state.product, state.selected, option.name, value)) button.classList.add('is-unavailable');
          list.appendChild(button);
        });
        block.appendChild(list);
      }
      wrap.appendChild(block);
    });
  };

  const renderModal = (product) => {
    const root = ensureModal();
    const firstAvailable = (product.variants || []).find((variant) => variant.available) || product.variants?.[0];
    state.product = product;
    state.quantity = 1;
    state.selected = {};
    (product.options || []).forEach((option, index) => {
      state.selected[option.name] = firstAvailable?.[`option${index + 1}`] || option.values?.[0];
    });
    const images = uniqueImages(product);
    state.image = absUrl(firstAvailable?.featured_image?.src) || images[0] || '';

    root.querySelector('.gh-qv__vendor').textContent = product.vendor || '';
    root.querySelector('.gh-qv__title').textContent = product.title || '';
    root.querySelector('.gh-qv__qty-value').textContent = '1';
    root.querySelector('.gh-qv__status').textContent = '';

    const thumbs = root.querySelector('.gh-qv__thumbs');
    thumbs.innerHTML = '';
    images.slice(0, 4).forEach((src) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gh-qv__thumb';
      button.dataset.src = src;
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      button.appendChild(img);
      thumbs.appendChild(button);
    });

    const carousel = root.querySelector('.gh-qv__carousel');
    carousel.innerHTML = '';
    carousel.classList.toggle('is-single', images.length < 2);
    images.forEach((src) => {
      const slide = document.createElement('div');
      slide.className = 'gh-qv__slide';
      slide.dataset.src = src;
      const slideImg = document.createElement('img');
      slideImg.src = src;
      slideImg.alt = product.title || '';
      slide.appendChild(slideImg);
      carousel.appendChild(slide);
    });

    renderOptions(root);
    renderPrice(root);
    renderImage(root, true);
    window.scrollTo(0, 0);
    root.hidden = false;
    document.body.classList.add('gh-qv-open');
    positionMobileSheet(root);
    requestAnimationFrame(() => {
      positionMobileSheet(root);
      requestAnimationFrame(() => positionMobileSheet(root));
    });
    const mobile = window.matchMedia('(max-width: 639px)').matches;
    const closeButton = mobile
      ? root.querySelector('.gh-qv__close--mobile')
      : root.querySelector('.gh-qv__close--desktop');
    closeButton?.focus();
  };

  const positionMobileSheet = (root) => {
    if (!root || window.matchMedia('(max-width: 639px)').matches === false) {
      root?.style.removeProperty('--gh-qv-sheet-top');
      root?.style.removeProperty('--gh-qv-close-top');
      root?.style.removeProperty('--gh-qv-close-right');
      return;
    }
    const collectionHeader = document.querySelector('.section--collection-header');
    const siteHeader = document.querySelector('.section--header');
    const headerBottom = collectionHeader
      ? collectionHeader.getBoundingClientRect().bottom
      : siteHeader?.getBoundingClientRect().bottom || 60;
    const desc = collectionHeader?.querySelector('.gh-collection-header__short-description');
    if (desc && !desc.dataset.ghQvNormalized) {
      desc.querySelectorAll('*').forEach((node) => {
        node.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE) {
            child.textContent = child.textContent.replace(/[\u2028\u2029]/g, '\n');
          }
        });
      });
      desc.dataset.ghQvNormalized = 'true';
    }
    const descHasText = Boolean(desc && desc.innerText.replace(/\s+/g, ' ').trim());
    const overlayTarget = descHasText
      ? desc
      : collectionHeader?.querySelector('h1') || collectionHeader;
    let closeTop = headerBottom - 40;
    if (overlayTarget) {
      const range = document.createRange();
      range.selectNodeContents(overlayTarget);
      const rects = [...range.getClientRects()].filter((rect) => rect.width > 1 && rect.height > 1);
      const box = overlayTarget.getBoundingClientRect();
      const first = rects[0] || box;
      const last = rects[rects.length - 1] || first;
      closeTop = (first.top + last.bottom) / 2 - 16;
    }
    const sheetTop = Math.max(44, Math.round(headerBottom) - 14);
    root.style.setProperty('--gh-qv-sheet-top', `${sheetTop}px`);
    root.style.setProperty('--gh-qv-close-top', `${Math.max(4, Math.min(Math.round(closeTop), sheetTop - 42))}px`);
  };

  const onViewportChange = () => {
    const root = document.querySelector('.gh-qv');
    if (root && !root.hidden) positionMobileSheet(root);
  };
  window.addEventListener('resize', onViewportChange);

  const closeModal = () => {
    const root = document.querySelector('.gh-qv');
    if (!root) return;
    root.hidden = true;
    document.body.classList.remove('gh-qv-open');
    root.style.removeProperty('--gh-qv-sheet-top');
    root.style.removeProperty('--gh-qv-close-top');
    root.style.removeProperty('--gh-qv-close-right');
  };

  const fetchProduct = async (handle) => {
    if (cache[handle]) return cache[handle];
    const rootUrl = Shopify?.routes?.root || '/';
    const response = await fetch(`${rootUrl}products/${handle}.js`);
    if (!response.ok) throw new Error('Unable to load product');
    const product = await response.json();
    cache[handle] = product;
    return product;
  };

  const openQuickView = async (handle) => {
    if (!handle) return;
    const root = ensureModal();
    root.querySelector('.gh-qv__status').textContent = '';
    try {
      const product = await fetchProduct(handle);
      renderModal(product);
    } catch (error) {
      root.hidden = false;
      document.body.classList.add('gh-qv-open');
      root.querySelector('.gh-qv__status').textContent = 'Unable to open quick view.';
    }
  };

  const refreshCart = (cart) => {
    Object.entries(cart?.sections || {}).forEach(([sectionId, sectionHtml]) => {
      if (!sectionHtml) return;
      window.dispatchEvent(
        new CustomEvent(`theme:cart:${sectionId.replace(/^cart-/, '')}:updateHtml`, {
          detail: { section: sectionHtml, load_transitions: false }
        })
      );
    });
    if (window.trigger) window.trigger('theme:cart:refresh');
    const drawer = document.querySelector('drawer-element');
    if (drawer && typeof drawer.open === 'function') drawer.open('right', 'cart-drawer');
  };

  const addToBag = async () => {
    const variant = findVariant(state.product, state.selected);
    const root = ensureModal();
    const button = root.querySelector('.gh-qv__add');
    const status = root.querySelector('.gh-qv__status');
    if (!variant?.available) return;
    button.disabled = true;
    status.textContent = '';
    try {
      const cartElement = document.querySelector('cart-element');
      const payload = {
        items: [{ id: variant.id, quantity: state.quantity }],
        sections: cartElement?.constructor?.sections || ['cart-drawer']
      };
      if (cartElement?.constructor?.addItems) {
        await cartElement.constructor.addItems(
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          },
          button
        );
        closeModal();
        return;
      }
      const addUrl = `${Shopify?.routes?.cart_add || '/cart/add'}.js`.replace(/\.js\.js$/, '.js');
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to add this item.');
      refreshCart(cart);
      closeModal();
    } catch (error) {
      status.textContent = error.message || 'Unable to add this item.';
      button.disabled = false;
    }
  };

  const handleFromTarget = (target) => {
    const quickAdd = target.closest('.product-quick-add, usf-product-quick-add');
    return (
      quickAdd?.dataset?.handle ||
      target.closest('.product-card--root')?.dataset?.handle ||
      target.closest('[data-handle]')?.dataset?.handle ||
      ''
    );
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest && event.target.closest('.product-quick-add--button, [data-gh-quick-view]');
      if (!button) return;
      const onFeaturedCard = Boolean(button.closest('.gh-featured-product-card'));
      if (
        !document.body.classList.contains('template--collection') &&
        !button.matches('[data-gh-quick-view]') &&
        !onFeaturedCard
      ) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      openQuickView(handleFromTarget(button));
    },
    true
  );
})();
